import { useSyncExternalStore } from 'react';

import {
  getSeasonPreference,
  setSeasonPreference,
  subscribeSeasonPreference,
} from '@features/seasonal-theme/utils/season-preference';

export const useSeasonPreference = () => {
  const preference = useSyncExternalStore(subscribeSeasonPreference, getSeasonPreference);

  return { preference, setPreference: setSeasonPreference };
};
